<div [formGroup]="form" class="gup-C-flexGroup -row -justifyBetween -alignCenter">

    <app-shared-month-and-year-picker [monthLabel]="startMonthYearLabel"
                                      class="gup-C-flexGroup__item -demi"
                                      formControlName="startMonthYear">
    </app-shared-month-and-year-picker>

    <div *ngIf="!displayMonthYearEnd; else displayMonthYearEndInputTemplate"
         class="gup-C-monthRange__link gup-C-flexGroup__item">
        <a (click)="toggleMonthYearEnd()"
           class="gup-O-link -secondary">
            Définir une période
        </a>
    </div>

    <ng-template #displayMonthYearEndInputTemplate>

        <span class="gup-C-flexGroup__item gup-C-numberRange__text">à</span>

        <app-shared-month-and-year-picker [monthLabel]="endMonthYearLabel"
                                          class="gup-C-flexGroup__item -demi"
                                          formControlName="endMonthYear">
        </app-shared-month-and-year-picker>

    </ng-template>

</div>

<ul *ngIf="form.errors">
    <li *ngFor="let errorMessage of getErrorMessages(form.errors)" class="gup-O-msg -error">
        - {{ errorMessage }}
    </li>
</ul>
